<template>
    <div>
     <div v-bind:class="['container container-paddingb', {'pt-5' : width > 768}, {'pt-3':width<=768} ]">
       <div class="row mt-5 container-paddingb">
         <div class="col-lg-6 col-md-12">
           <div id="form-container" v-if="!thanks_show">
           <h1 class=" title dark-grey roboto-style font-weight-bold">Contact us</h1>
           <p class=" inter-style medium-grey description mt-4 mb-0">Do you have a question? Do you have feedback?</p>
           <p class=" inter-style medium-grey description mt-0">We look forward to receiving a call or email from you.</p>
           <p class=" inter-style medium-grey description">On average, you’ll hear from us within 3 hours.</p>
             <form novalidate id="contactform" v-bind:class="['needs-validation inter-style dark-grey xs_margint', {'mt-5' : width > 1023}]">
               <div class="row">
                 <div class="col-md-6">
                   <div class="form-group" style="margin-bottom: 30px">
                     <label for="fullname">Full name</label>
                     <input tabindex="1" v-on:blur="fullnameBlured = true" v-bind:class="{'form-control':true, 'is-invalid' : !validName(fullname) && fullnameBlured}"id="fullname" name="fullname" type="text" v-model="fullname" />
                     <span class="invalid-feedback">Full name must have at least 2 characters</span>
                   </div>
                 </div>
                 <div class="col-md-6">
                 <div class="form-group" style="margin-bottom: 30px">
                   <label for="email">E-mail address</label>
                   <input tabindex="2" v-on:blur="emailBlured = true" v-bind:class="{'form-control':true, 'is-invalid' : !validEmail(email) && emailBlured}" id="email" name="email" type="text" v-model="email"/>
                   <span class="invalid-feedback">A valid email is required</span>
                 </div>
                 </div>
               </div>
               <div class="row">
                 <div class="col-md-6">
                   <div class="form-group" style="margin-bottom: 30px">
                    <label for="companyname">Company name </label><span class="mt-1 pull-right medium-grey font-italic smallsize-txt">optional</span>
                    <input tabindex="3" @change="changecompanyValidation" v-on:blur="companynameBlured = true" v-bind:class="{'form-control':true, 'is-invalid' : !isValidCompany}" id="companyname" name="companyname" type="text" v-model="companyname"/>
                     <span class="invalid-feedback">Company name must have at least 2 characters</span>
                   </div>
                 </div>
                 <div class="col-md-6">
                   <div class="form-group">
                     <label for="phone">Phone number</label><span class="mt-1 pull-right medium-grey font-italic smallsize-txt">optional</span>
                     <input tabindex="4" @change="changephoneValidation" v-on:blur="phoneBlured = true" v-bind:class="{'form-control':true, 'is-invalid' : !isValidPhone}" id="phone" name="phone" type="text" v-model="phone"/>
                     <span class="invalid-feedback">A valid phone is required</span>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <div class="col-md-6">
               <div class="form-group" style="margin-bottom: 30px">
                 <label for="scopeselect">How can we help?</label>
                 <select tabindex="5"  required class="form-control" id="scopeselect" name="scopeselect" v-model="scopeselect">
                   <option :selected="scopeselect == 'Potential project'">Potential project</option>
                   <option :selected="scopeselect == 'Request case study'">Request case study</option>
                 </select>
               </div>
                 </div>
               </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group" style="margin-bottom: 30px">
                      <label for="message">Message</label>
                      <textarea tabindex="6" rows="5" v-on:blur="messageBlured = true" v-bind:class="{'form-control':true, 'is-invalid' : !validMessage(message) && messageBlured}" id="message" name="message" type="text" v-model="message"></textarea>
                      <span class="invalid-feedback">The message must have at least 20 characters</span>
                    </div>
                  </div>
                </div>
               <div class="row">
                 <div class="col-md-12">
                 <div v-bind:class="['form-group xs_marginb', {'mb-5' : width > 1023}]">
                   <div class="row ml-0">
                     <input tabindex="7" v-bind:class="{'form-control':true, 'is-invalid' : !privacyChecked && !privacy}" required type="checkbox" id="privacy" name="privacy" :value="privacy" v-model="privacy">
                     <span class="checkmark"></span>
                     <label ref="privacyLabel" class="col-md-11 inter-style smallsize-txt" style="padding-left: 30px" for="privacy">I am hereby consenting that Unknown Software LLC can process my personal data for the purpose of making me an offer for their services.</label>
                       <span ref="privacyError" class="col-md-12 px-0 invalid-feedback">This is mandatory</span>
                   </div>
                 </div>
                 </div>
               </div>
               <div class="row">
                 <div class="col-md-12">
                   <a tabindex="8" :disabled="inProgress" @click.stop.prevent="submit" class="d-inline-block font-weight-bold dark-grey button greenbtn smallbtn roboto-style">Submit<arrow></arrow></a>
                   <span v-if="ajaxError" class="col-md-12 px-0 invalid-feedback" style="margin-top: 17px; display: block!important;">We are sorry, data could not be sent. Pleaase try again later.</span>
                 </div>
               </div>
             </form>
         </div>
         <transition name="fade" mode="out-in">
           <div id="thanks" class="col-md-12 text-center roboto-style" v-if="thanks_show">
             <h1 class="title">Thank you!</h1>
             <div class="col-md-12 mx-0">
               <successicn></successicn>
             </div>
             <p v-if="ajaxSuccess" class="description">We will contact you as soon as possible.</p>
             <p v-if="ajaxAlready" class="description">Already subscribed</p>
           </div>
         </transition>
         </div>
         <div class="col-lg-5 offset-lg-1 col-md-12" style="margin-top: 80px">
           <div class="col-md-12 lightgrey-container" v-bind:style="width >= 768 ? 'padding: 40px' : 'padding: 30px 10px;'">
             <h2 class="small-description roboto-style dark-grey font-weight-bold mb-5">Working with us will bring you:</h2>
             <div class="row medium-grey small-description inter-style">
               <ul id="contact_ul">
                 <li>A very short response time</li>
                 <li>High-performance products for your business</li>
                 <li>30 days of free maintenance</li>
                 <li>Fostering long-term relationships with big clients</li>
                 <li>Unexpected revenue</li>
                 <li>Partners all the way</li>
               </ul>
             </div>
             <h2 class="small-description roboto-style dark-grey font-weight-bold mb-4 mt-4">You are in good company:</h2>
             <div v-bind:class="['row', {'text-center' : width < 768}]">
               <div v-bind:class="['col-lg-4 col-md-2 col-4 d-flex align-items-center justify-content-center', {'mt-3' : width < 768}]"><img class="img-fluid" src="../assets/groupon.png"/></div>
               <div v-bind:class="['col-lg-4 col-md-2 col-4 d-flex align-items-center justify-content-center', {'mt-3' : width < 768}]"><img class="img-fluid" src="../assets/ferrero.png"/></div>
               <div v-bind:class="['col-lg-4 col-md-2 col-4 d-flex align-items-center justify-content-center', {'mt-3' : width < 768}]"><img class="img-fluid" src="../assets/carlsberg.png"/></div>
             </div>
             <div v-bind:class="['row', {'mt-3 text-center' : width < 768}, {'mt-4' : width >= 768}]">
               <div v-bind:class="['col-lg-4 col-md-2 col-4 d-flex align-items-center justify-content-center', {'mt-3' : width < 768}]"><img class="img-fluid" src="../assets/coca-cola.png"/></div>
               <div v-bind:class="['col-lg-4 col-md-2 col-4 d-flex align-items-center justify-content-center', {'mt-3' : width < 768}]"><img class="img-fluid" src="../assets/vodafone.png"/></div>
               <div v-bind:class="['col-lg-4 col-md-2 col-4 d-flex align-items-center justify-content-center mt-1', {'mt-3' : width < 768}]"><img class="img-fluid"  src="../assets/gdf-suez.png"/></div>
             </div>
           </div>
         </div>
       </div>
     </div>
    </div>
</template>

<script>
  import checkcirle from './check-circle';
  import Arrow from './arrow';
  import successicn from './successicn';
  export default {
      components: {
          checkcirle: checkcirle,
          arrow: Arrow,
          successicn
      },
      data() {
          return {
              fullname: '',
              companyname: '',
              phone: '',
              email: '',
              message: '',
              privacy: false,
              valid: false,
              emailBlured: false,
              fullnameBlured: false,
              companynameBlured: false,
              phoneBlured: false,
              messageBlured: false,
              isValidCompany: true,
              isValidPhone: true,
              privacyChecked: true,
              width: 0,
              thanks_show: false,
              ajaxError: false,
              inProgress: false,
              ajaxSuccess: false,
              ajaxAlready: false,
              errorMessage: ''
          }
      },
      mounted() {
          this.thanks_show = false;
          this.width = window.innerWidth;
          window.addEventListener('resize', () => {
              this.windowWidth = window.innerWidth;
          });
          this.matchHeight();
      },
      computed: {
        scopeselect() {
            if (this.$route.path == "/request-case-study") {
                return 'Request case study';
            } else {
                return 'Potential project';
            }
        },
          windowWidth: {
              get: function () {
                  return this.width;
              },
              set: function (val) {
                  this.width = val;
              }

          },
      },
      methods: {
          matchHeight() {
            var privacyHeight = this.$refs.privacyLabel.clientHeight + 5 + 'px';
            this.$refs.privacyError.style.marginTop = privacyHeight;
          },
          changecompanyValidation() {
            if(this.companyname == '') {
                this.isValidCompany = true;
            }
          },
          changephoneValidation() {
              if(this.phone == '') {
                  this.isValidPhone = true;
              }
          },
          validEmail(input) {
              var re = /(.+)@(.+){2,}\.(.+){2,}/;
              return re.test(input.toLowerCase());
          },
          validPhone(input) {
              if(input != '') {
                  var re = /^[0-9]*$/;
                  return re.test(input.toLowerCase());
              } else {
                  return true;
              }

          },
          validName(input) {
              var re = /^.{2,}$/;
              return re.test(input.toLowerCase());
          },
          validCompany(input) {
              if(input != '') {
                  var re = /^.{2,}$/;
                  return re.test(input.toLowerCase());
              } else {
                  return true;
              }

          },
          validMessage(input) {
              var re = /^.{20,}$/;
              return re.test(input.toLowerCase());
          },
          validate() {
              if( this.validEmail(this.email) && this.validPhone(this.phone) && this.validName(this.fullname) && this.validCompany(this.companyname) && this.validMessage(this.message) && this.privacy) {
                  this.valid = true;
              } else {
                  this.valid = false;
                  if (!this.validEmail(this.email)) {
                      this.emailBlured = true;
                  }
                  if (!this.validName(this.fullname)) {
                      this.fullnameBlured = true;
                  }
                  if (!this.validMessage(this.message)) {
                      this.messageBlured = true;
                  }
                  if(!this.validCompany(this.companyname) && this.companyname != '') {
                      this.isValidCompany = false;
                  }
                  if(!this.validPhone(this.phone) && this.phone != '') {
                      this.isValidPhone = false;
                  }
                  if(!this.privacy) {
                      this.privacyChecked = false;
                  } else {
                      this.privacyChecked = true;
                      this.privacyChecked = true;
                  }
              }
          },
          submit() {
              this.inProgress = true;
              var self = this;
                this.validate();
                if(this.valid) {
                    let formobj = this;
                    var data = new FormData();
                    data.append('name', formobj.fullname);
                    data.append('email', formobj.email);
                    data.append('scope', formobj.scopeselect);
                    data.append('message', formobj.message);
                    data.append('phone', formobj.phone);
                    data.append('company', formobj.companyname);
                    this.axios.post("contact.php", data)
                        .then(function(response) {
                            formobj.valid = true;
                            formobj.fullname = '';
                            formobj.companyname = '';
                            formobj.phone = '';
                            formobj.email = '';
                            formobj.message = '';
                            formobj.fullnameBlured = false;
                            formobj.messageBlured = false;
                            formobj.emailBlured = false;
                            formobj.companynameBlured = false;
                            formobj.phoneBlured = false;
                            formobj.privacy = false;
                            formobj.privacyChecked = true;
                            self.inProgress = true;
                            console.log(response);
                            if(response.data == 1) {
                                self.ajaxSuccess = true;
                            }
                            if(response.data == "Already subscribed") {
                                self.ajaxAlready = true;
                            }
                            if (response.data == 1 || response.data == "Already subscribed") {
                                document.documentElement.scrollTop = 0;
                                self.thanks_show = true;
                            }
                        })
                        .catch(function(error) {
                            self.ajaxError = true;
                            self.errorMessage = error.response;
                        });
                }
          }
      }
  }
</script>

<style scoped lang="scss">
  .invalid-feedback {
    position: absolute;
  }
  .is-invalid {
    border-color: #dc3445!important;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>




// WEBPACK FOOTER //
// src/components/contactform.vue